const referrerIsSameAsSite = () => {
  return traffic => {
    if (traffic.referrer === '') {
      return false
    }
    const urlObject = new URL(traffic.url.toLowerCase())
    const referrerObject = new URL(traffic.referrer.toLowerCase())
    return urlObject.hostname === referrerObject.hostname
  }
}

export default referrerIsSameAsSite



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/referrerIsSameAsSite.js